import React from "react"
import { motion } from "framer-motion"
import { Box, Grid, Link, Flex, Text } from "theme-ui"


export function Pager({ children, value }) {

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <motion.div
        style={{
          flexDirection: "row",
          direction: "ltr",
          willChange: "transform",
          minHeight: 0,
          flex: 1,
          display: "flex",
        }}
        transition={{
          tension: 190,
          friction: 70,
          mass: 0.4,
        }}
        initial={false}
        animate={{ x: value * -100 + "%" }}
      >
        {React.Children.map(children, (child, i) => (
          <Box
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignSelf: "stretch",
            justifyContent: "flex-start",
            flexShrink: 0,
            height: "100%",
            overflow: "hidden",
            outline: "none"
          }}

            key={i}
            aria-hidden={value !== i}
            tabIndex={value === i ? 0 : -1}
          >
            {child}
          </Box>
        ))}
      </motion.div>
    </Box>
  )
}
